import { useGetProjectQuery } from 'app/services/projectBoardApi';
import ProjectStatusChip from './ProjectStatusChip';

/**
 * Container header (#container_header, ContainerHeaderView →
 * tmpl/container_header.tmpl), inventory §2/§3.3 / parity 36:
 * `h3.left {project name}` + `span#project_status.project-status.status`
 * (ProjectStatusView renders into the span). Renames live-update via the
 * shared getProject cache (Backbone listenTo change:name re-render).
 *
 * [NEG] honored: ContainerHeaderItemView is never instantiated — not built
 * (inventory §3.5 / parity 39).
 */
const BoardContainerHeader = ({ projectId }: { projectId: number }) => {
  const { data: project } = useGetProjectQuery(projectId, {
    skip: !Number.isFinite(projectId),
  });

  return (
    <div id="container_header" className="container-header col-xs-12">
      <h3 className="left ">{project?.name ?? ''}</h3>
      <span id="project_status" className="project-status status">
        <ProjectStatusChip projectId={projectId} />
      </span>
    </div>
  );
};

export default BoardContainerHeader;
